import { render, staticRenderFns } from "./RemoveCard.vue?vue&type=template&id=44c91268"
import script from "./RemoveCard.vue?vue&type=script&lang=js"
export * from "./RemoveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports